import { calculateCleanBox } from '../scene/object-geometry.js?v=20260817-relbridge9';
import { ramCoolerPairCompatibility } from '../simulator/ram-clearance.js?v=20260817-boardfan3';

function setEmissiveColorRecursive(object, hexColor) {
  if (object?.material) {
    const materials = Array.isArray(object.material) ? object.material : [object.material];
    materials.forEach(material => {
      if (material?.emissive && typeof material.emissive.setHex === 'function') material.emissive.setHex(hexColor);
    });
  }
  for (const child of object?.children || []) setEmissiveColorRecursive(child, hexColor);
}

export function createConflictVisualizer({ getActiveBoxes, getLayoutFamily, now, recordPass } = {}) {
  function run() {
    const startedAt = now?.() ?? Date.now();
    const activeBoxes=getActiveBoxes?.() || [];
    const cases = activeBoxes.filter(item => item?.isCase);
    const components = activeBoxes.filter(item => item?.isComponent);
    const bounds = new Map();
    const insetBounds = new Map();
    const conflicts = new Set();

    for (const item of [...cases, ...components]) {
      const box = calculateCleanBox(item);
      bounds.set(item.uid, box);
      if (item.isComponent) insetBounds.set(item.uid, box.clone().expandByScalar(-0.2));
    }

    const ignorePair = (a, b) => {
      if (a.attachedToMoboUid === b.uid || b.attachedToMoboUid === a.uid) return true;
      const ramPair=ramCoolerPairCompatibility(a,b);
      if(ramPair?.compatible)return true;
      if (a.pcieAttachedToMoboUid === b.uid || b.pcieAttachedToMoboUid === a.uid) return true;
      if (a.attachedToRadiatorUid === b.uid || b.attachedToRadiatorUid === a.uid) return true;
      return getLayoutFamily?.() === 'reference'
        && ((a.trackType === 'motherboard' && b.trackType === 'gpu') || (a.trackType === 'gpu' && b.trackType === 'motherboard'));
    };

    for (let i = 0; i < components.length; i++) {
      const a=components[i];
      const aBox=insetBounds.get(a.uid);
      for (let j=i+1; j<components.length; j++) {
        const b=components[j];
        const ramPair=ramCoolerPairCompatibility(a,b);
        if(ramPair?.known && !ramPair.compatible){
          conflicts.add(a.uid);
          conflicts.add(b.uid);
          continue;
        }
        if (ignorePair(a,b)) continue;
        if (aBox?.intersectsBox(insetBounds.get(b.uid))) {
          conflicts.add(a.uid);
          conflicts.add(b.uid);
        }
      }
    }

    for (const comp of components) {
      const compBox=bounds.get(comp.uid);
      for (const caseObj of cases) {
        const caseBox=bounds.get(caseObj.uid);
        if (compBox?.intersectsBox(caseBox) && !caseBox.containsBox(compBox)) {
          conflicts.add(comp.uid);
          break;
        }
      }
      const hasConflict=conflicts.has(comp.uid);
      setEmissiveColorRecursive(comp, hasConflict ? 0x550000 : 0x000000);
      if (comp.badgeEl) comp.badgeEl.style.color = hasConflict ? '#ef4444' : '';
    }

    recordPass?.((now?.() ?? Date.now()) - startedAt);
  }

  return { run };
}
